import React from "react"

const UserEmailAddressEditList = ({
    emails,
    primary_email,
    onChange,
    onDelete
}) => {
    const deleteEmail = (emails, email) => {
        onDelete(emails.filter(currentEmail => email !== currentEmail))
    }

    return (
        <div className="margin-top--5">
            {emails.map(function(email, index) {
                return (
                    <p key={index}>
                        <i
                            className={`icon ${
                                primary_email === email
                                    ? "icon-checked"
                                    : "icon-unchecked"
                            }`}
                            onClick={() => onChange(email)}
                        />
                        {email}
                        <i
                            className="icon icon-remove side-button"
                            onClick={() => deleteEmail(emails, email)}
                        />
                    </p>
                )
            })}
        </div>
    )
}

export default UserEmailAddressEditList
